import { useState } from 'react';
import moment from 'moment';
import RRuleForm from 'components/agenda/RRuleForm';
import { useTranslation } from 'react-i18next';

const EventForm = ({ disabled }) => {
  const { t } = useTranslation();

  const [repeating, setRepeat] = useState(false);
  const [rrule, setRRule] = useState('RRULE:FREQ=DAILY;INTERVAL=1');

  return (
    <div className="row mb-4 col-8">
      <div className="col-8 form-group mb-3">
        <label htmlFor="titleInput">{t('agenda.form.title.label')}:</label>
        <input type="text" className="form-control" name="title" id="title" disabled={disabled} />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="dateInput">{t('agenda.form.date.label')}:</label>
        <input
          type="date"
          className="form-control"
          defaultValue={moment().format('YYYY-MM-DD')}
          min={moment().format('YYYY-MM-DD')}
          id="dateInput"
          name="date"
          disabled={disabled}
          required
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="timeInput">{t('agenda.form.time.label')}:</label>
        <input type="time" name="time" defaultValue={moment().format('HH:mm')} className="form-control" id="timeInput" disabled={disabled} required />
      </div>

      <div className="col-12 form-group mt-3">
        <div className="form-group form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="repeatingCheckInput"
            checked={repeating}
            onChange={e => setRepeat(e.target.checked)}
          />

          <label className="form-check-label" htmlFor="repeatingCheckInput">
            {t('agenda.actions.repeat')}
          </label>
        </div>
      </div>
      <RRuleForm show={repeating} value={rrule} onChange={rrule => setRRule(rrule)} />
      <input type="hidden" name="rrule" value={repeating ? rrule : ''} />
    </div>
  );
};

export default EventForm;
